import { useState } from 'react';
import { paymentService } from '../api';
import { PaymentData, Payment, PaymentRequest, PaymentResponse } from '../types';

interface UsePaymentProcessProps {
  currentToken: string | null;
  paymentData: PaymentData | null;
  setError: (error: string | null) => void;
  setLoading: (loading: boolean) => void;
}

export const usePaymentProcess = ({ currentToken, paymentData, setError, setLoading }: UsePaymentProcessProps) => {
  const [paymentFormData, setPaymentFormData] = useState<PaymentResponse | null>(null);

  const handlePaymentClick = async (payment: Payment): Promise<void> => {
    if (!currentToken || !paymentData) {
      setError('Nema dostupnih podataka za plaćanje');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Kreiranje payment request objekta
      const paymentRequest: PaymentRequest = {
        token: currentToken,
        amount: payment.amount,
        pnbModel: payment.pnbModel,
        pnb: payment.pnb,
        cartContent: payment.cartContent,
        paymentType: payment.paymentType,
        firstName: paymentData.firstName,
        lastName: paymentData.lastName,
        userAddress: paymentData.userAddress,
        userCity: paymentData.userCity,
        userPostalCode: paymentData.userPostalCode,
        userCountry: paymentData.userCountry,
        userPhone: paymentData.userPhone,
        userEmail: paymentData.userEmail,
        source: paymentData.source,
        sourceId: paymentData.sourceId,
        legalPersonName: paymentData.legalPersonName
      };

      // Poziv prepare-payment API-ja
      const paymentResponse = await paymentService.preparePayment(paymentRequest);
      
      // Postavljanje podataka za auto-submit formu
      setPaymentFormData(paymentResponse);
      
    } catch (err: any) {
      let errorMsg = 'Greška pri pripremi plaćanja';
      
      if (err.response?.data) {
        const responseData = err.response.data;
        
        if (Array.isArray(responseData) && responseData[0] && responseData[0].message) {
          errorMsg = responseData[0].message;
        } else if (typeof responseData === 'object' && responseData.message) {
          errorMsg = responseData.message;
        }
      }
      
      setError(errorMsg);
      console.error('Payment preparation error:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    paymentFormData,
    handlePaymentClick
  };
};